import { render, staticRenderFns } from "./CartPage.vue?vue&type=template&id=2a4f9f10&scoped=true&"
import script from "./CartPage.vue?vue&type=script&lang=js&"
export * from "./CartPage.vue?vue&type=script&lang=js&"
import style0 from "./CartPage.vue?vue&type=style&index=0&id=2a4f9f10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4f9f10",
  null
  
)

export default component.exports